<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-tree-outline"
          inline
          class="px-5 py-4 ml-0"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Gerências
            </div>
          </template>

          <v-btn
            id="btn-nova-gerencia"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push('/administracao/gerencias/add')"
          >
            <v-icon left size="30px">
              mdi-plus-circle
            </v-icon>
            Nova Gerência
          </v-btn>

          <v-text-field
            id="gerencias-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mt-4 break-search bs-gerencias"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="gerencias-table"
            :headers="headers"
            :items="gerencias"
            :search.sync="search"
            :sort-by="['updated_at']"
            :sort-desc="[true]"
            :headerProps="{
              sortByText: 'Ordenar Por',
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página',
            }"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            :mobile-breakpoint="800"
            no-data-text="Nenhuma Gerência encontrada"
            no-results-text="Nenhuma Gerência correspondente encontrada"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id | addLeadingZero }}
            </template>
               <template v-slot:[`item.descricao`]="{ item }">
              {{ item.descricao || '-' }}
            </template>
            <template v-slot:[`item.regional`]="{ item }">
              {{ item.regional ? item.regional.nome : 'N/A' }}
            </template>
            <template v-slot:[`item.tipos_servicos`]="{ item }">
              <a
                href="javascript:void(0)"
                @click.stop="openTiposServicosDialog(item.tipos_servicos)"
              >
                {{ item.tipos_servicos.length | addLeadingZero }}
              </a>
            </template>
            <template v-slot:[`item.municipios`]="{ item }">
              <a
                href="javascript:void(0)"
                @click.stop="openMunicipiosDialog(item.municipios)"
              >
                {{ item.municipios.length | addLeadingZero }}
              </a>
            </template>
            <template v-slot:[`item.created_by`]="{ item }">
              {{ item.user ? item.user.name : "Sistema" }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | parseToDateTimeBR }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="edit-gerencias"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                @click="
                  $router.push(`/administracao/gerencias/edit/${item.id}`)
                "
              >
                <v-icon small>
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
              <v-btn
                id="delete-gerencias"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                @click="openDialogDelete(item)"
              >
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <!-- Dialog de Tipos de Serviços -->
    <v-dialog v-model="tiposServicosDialog" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">Tipos de Serviços</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :headers="[
              { text: 'Código', value: 'codigo' },
              { text: 'Nome', value: 'nome' },
              { text: 'Categoria', value: 'categoria' },
            ]"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [10, 50, 100, 300, -1],
              itemsPerPage: -1,
            }"
            :items-per-page="-1"
            :items="tiposServicosDialogData"
            class="elevation-1"
            no-data-text="Nenhum tipo de serviço listado"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="tiposServicosDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Municípios -->
    <v-dialog v-model="municipiosDialog" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">Municípios</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :headers="[
              { text: 'Código IBGE', value: 'codigo_municipio' },
              { text: 'Município', value: 'nome_municipio' },
              { text: 'UF', value: 'nome_uf' },
            ]"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [10, 50, 100, 300, -1],
              itemsPerPage: -1,
            }"
            :items-per-page="-1"
            :items="municipiosDialogData"
            class="elevation-1"
            no-data-text="Nenhum município listado"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="municipiosDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de confirmação para exclusão -->
    <dialog-delete
      :dialog.sync="dialogDelete"
      @submitTriggered="deleteGerencia(dialogDeleteData.id)"
    >
      <template slot="title">
        Deletar Gerência #{{ dialogDeleteData.id }}
      </template>
      <template slot="body">
        Tem certeza que deseja deletar a gerência 
        <strong>{{ dialogDeleteData.nome }}</strong
        >?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import tourMixins from "@/mixins/tourMixins";
  import GerenciasService from "@/services/GerenciasService";

  export default {
    name: "GerenciasIndex",
    mixins: [tourMixins],
    components: {
      DialogDelete: () => import("@/components/general/DialogDelete"),
    },
    data() {
      return {
        headers: [
          {
            text: "#",
            value: "id",
          },
          {
            text: "Nome",
            value: "nome",
          },
          {
            text: "Descrição",
            value: "descricao",
          },
          {
            text: "Regional",
            value: "regional",
          },
          {
            text: "Tipos de Serviços",
            value: "tipos_servicos",
          },
          {
            text: "Criado por",
            value: "created_by",
          },
          {
            text: "Municípios",
            value: "municipios",
          },
          {
            text: "Modificado em",
            value: "updated_at",
          },
          {
            sortable: false,
            text: "Ações",
            value: "actions",
            class: "pl-4",
          },
        ],
        gerencias: [],
        search: "",
        loading: false,
        arrTour: [
          {
            element: "#btn-nova-gerencia",
            intro:
              "Clicando neste botão você poderá cadastrar novas Gerências.",
            scrollTo: "tooltip",
            position: "right",
          },
          {
            element: "#gerencias-search",
            intro:
              "Neste campo você poderá pesquisar por Gerências já cadastradas.",
            scrollTo: "tooltip",
            position: "bottom",
          },
        ],
        tiposServicosDialog: false,
        tiposServicosDialogData: [],
        municipiosDialog: false,
        municipiosDialogData: [],
        dialogDelete: false,
        dialogDeleteData: {
          id: undefined,
          nome: undefined,
        },
      };
    },
    computed: {
      //
    },
    mounted() {
      this.getGerencias();
    },
    methods: {
      getGerencias() {
        if (!this.$store.getters.getCompanyId) {
          this.$toast.info(
            "Selecione uma empresa para listar as gerências.",
            "",
            { position: "topRight" }
          );
        }

        this.loading = true;
        this.gerencias = [];

        GerenciasService.getAll()
          .then((data) => {
            this.gerencias = data;
          })
          .catch((err) => {
            this.$toast.error("Erro ao recuperar Gerências.", "", {
              position: "topRight",
            });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      openDialogDelete(item) {
        this.dialogDeleteData = {
          id: item.id,
          nome: item.nome,
        };
        this.dialogDelete = true;
      },
      deleteGerencia(id) {
        this.dialogDelete = false;
        this.dialogDeleteData = {
          id: undefined,
          nome: undefined,
        };

        return GerenciasService.delete(id)
          .then(() => {
            this.$toast.success("Gerência excluída com sucesso.", "", {
              position: "topRight",
            });
            this.getGerencias();
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao excluir Gerência.", "", {
              position: "topRight",
            });
          });
      },
      openTiposServicosDialog(tiposServicos) {
        this.tiposServicosDialogData = tiposServicos.map(tipo => ({
          codigo: tipo.codigo,
          nome:tipo.servico,
          categoria:tipo.categorias && tipo.categorias.length > 0 ? tipo.categorias[0].nome : '-'
        }));

        this.tiposServicosDialog = true;
      },
      openMunicipiosDialog(municipios) {
        this.municipiosDialogData = municipios;
        this.municipiosDialog = true;
      },
      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.gerencias.length
          ? this.arrTour
          : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      },
    },
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .gerencias-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .gerencias-table table tr td:nth-child(8) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-gerencias {
      width: 235.86px !important;
    }
  }
</style>
